<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <span> فیلتر </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="invoice_date" class="wh-label">
                    <span> تاریخ سند </span>
                    <div style="width:100%">
                        <input class="wh-input" matInput [matDatepicker]="picker" formControlName="invoice_date"
                            autocomplete="off" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker datepicker1" readonly>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </div>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="user" class='wh-label'>
                    <span> نام طرف حساب </span>
                    <span (click)="reset_input(161)">
                        <mat-icon class="close" class="input_search input_search_pe">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="user_title" (click)="open_user()" readonly>
                    <input class="wh-input" formControlName="user" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="comment" class='wh-label'>
                    <span> توضیحات فاکتور </span>
                    <input class='wh-input' formControlName="comment" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="invoice_number" class='wh-label'>
                    <span> شماره فاکتور </span>
                    <input class='wh-input' formControlName="invoice_number" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pe div_panding'>
                <label for="settlement_date" class="wh-label">
                    <span> تاریخ تسویه </span>
                    <div style="width:100%">
                        <input class="wh-input" matInput [matDatepicker]="picker2" formControlName="settlement_date"
                            autocomplete="off" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker2" class="datepicker datepicker1" readonly>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </div>
                </label>
            </div>
        </div>
        <!-- ********************************************************************************************************* -->
    </div><!-- content -->
    <div mat-dialog-actions class="matDialogActions">
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 right padding0">
                <button type="submit" class="btn_pe">
                    <span>فیلتر</span>
                </button>
            </div>
        </div><!-- row -->
    </div>
</form>